import PropTypes    from 'prop-types';
import React        from 'react';
import SaveOnChange from '../components/save_on_change';
import Switch       from 'react-switch';

export default function SwitchControl({ disabled, checked, save }) {
  return (
    <SaveOnChange save={save}>
      {(onChange, inProgress) => (
        <Switch
          checked={checked}
          disabled={inProgress || disabled}
          onChange={onChange}
          checkedIcon={false}
          uncheckedIcon={false}
        />
      )}
    </SaveOnChange>
  );
}

SwitchControl.propTypes = {
  save:    PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired
};
